import { TranslateService } from '@ngx-translate/core';

export function translateChartLabels(translate: TranslateService, item: string | number, type: 'day' | 'month' | 'year'): string {
  if (type === 'day') {
    switch (item) {
      case 'Monday':
        return translate.instant('dashboard.day.monday');
      case 'Tuesday':
        return translate.instant('dashboard.day.tuesday');
      case 'Wednesday':
        return translate.instant('dashboard.day.wednesday');
      case 'Thursday':
        return translate.instant('dashboard.day.thursday');
      case 'Friday':
        return translate.instant('dashboard.day.friday');
      case 'Saturday':
        return translate.instant('dashboard.day.saturday');
      case 'Sunday':
        return translate.instant('dashboard.day.sunday');
      default:
        return '';
    }
  } else if (type === 'year') {
    switch (item) {
      case 1:
        return translate.instant('dashboard.months.january');
      case 2:
        return translate.instant('dashboard.months.february');
      case 3:
        return translate.instant('dashboard.months.march');
      case 4:
        return translate.instant('dashboard.months.april');
      case 5:
        return translate.instant('dashboard.months.may');
      case 6:
        return translate.instant('dashboard.months.june');
      case 7:
        return translate.instant('dashboard.months.july');
      case 8:
        return translate.instant('dashboard.months.august');
      case 9:
        return translate.instant('dashboard.months.september');
      case 10:
        return translate.instant('dashboard.months.october');
      case 11:
        return translate.instant('dashboard.months.november');
      case 12:
        return translate.instant('dashboard.months.december');
      default:
        return '';
    }
  }

  return '';
}